module.exports = __webpack_public_path__ + "static/img/12.fc2409f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/clix/12.png
// module id = EfJl
// module chunks = 35